import { Button, Modal } from "antd";

import * as S from "./styles";

export const CreateCampaignModal = ({ open, onCancel, onSubmit }) => {
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);

    const title = formData.get("title")?.toString();

    await onSubmit({
      title,
    });
  };

  return (
    <Modal
      title="Registrar Nova Campanha"
      open={open}
      onCancel={onCancel}
      cancelText="Cancelar"
      destroyOnClose={true}
      closable={false}
      okButtonProps={{
        style: {
          display: "none",
        },
      }}
    >
      <S.Container onSubmit={handleSubmit}>
        <input type="text" name="title" placeholder="Título" />
        <Button type="primary" htmlType="submit" id="app-button">
          Registrar
        </Button>
      </S.Container>
    </Modal>
  );
};
